import React, { useMemo } from 'react';
import { FormItem, EditorInput } from 'components/elements';
import { Input, Select, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useSearchUsersQuery, useGetMyAccountQuery } from 'graphql/types';
import {
  ContactOptionRow,
  ContactOptionText,
  ContactOptionName,
  ContactOptionMeta,
} from 'components/elements/chatGroupModal/contactModal.styled';

function InformationStep() {
  const { data: usersData, loading: usersLoading } = useSearchUsersQuery({
    variables: { search: '', limit: 500 },
  });
  const { data: myAccount } = useGetMyAccountQuery();
  const currentUserId = myAccount?.myAccount?.data?.id;

  const managerOptions = useMemo(
    () =>
      (usersData?.usersForAutocomplete ?? [])
        .filter((user) => user.id !== currentUserId)
        .map((user) => {
          const displayName = [user.firstname, user.lastname].filter(Boolean).join(' ').trim();
          const username = user.username || user.name || user.email || user.id;
          const src = (user.avatarUrl || '').trim();
          return {
            value: user.id,
            username,
            searchText: [user.username, displayName, user.email].filter(Boolean).join(' ').toLowerCase(),
            label: (
              <ContactOptionRow>
                <Avatar size={24} src={src || undefined} icon={!src ? <UserOutlined /> : undefined} />
                <ContactOptionText>
                  <ContactOptionName>{username}</ContactOptionName>
                  {displayName ? <ContactOptionMeta>{displayName}</ContactOptionMeta> : null}
                </ContactOptionText>
              </ContactOptionRow>
            ),
          };
        }),
    [usersData, currentUserId],
  );

  return (
    <>
      <FormItem
        name="name"
        label="Title"
        theme="primary"
        rules={[
          {
            required: true,
            message: 'Please input your Email!',
          },
        ]}
      >
        <Input placeholder="Enter Your Group Title" />
      </FormItem>

      {/* <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.groupType !== currentValues.groupType}>
        {({ getFieldValue }) => {
          const groupType = getFieldValue('groupType');

          if ([EventTypeEnum.Physical, EventTypeEnum.Both].includes(groupType)) {
            return (
              <FormItem
                name="address"
                label="Location Address"
                theme="primary"
                rules={[
                  {
                    required: true,
                    message: 'Please input your Location Address!',
                  },
                ]}
              >
                <SearchBox />
              </FormItem>
            );
          }
          return null;
        }}
      </Form.Item> */}
      <FormItem name="managers" label="Group Managers" theme="primary">
        <Select
          mode="multiple"
          allowClear
          showSearch
          optionLabelProp="username"
          loading={usersLoading}
          placeholder="Search and select managers"
          options={managerOptions}
          filterOption={(input, option) => (option?.searchText ?? '').includes(input.toLowerCase())}
        />
      </FormItem>
      <FormItem
        name="description"
        label="Description"
        theme="primary"
        fullRounded={false}
        rules={[
          {
            required: true,
            message: 'Please input your Email!',
          },
        ]}
      >
        <EditorInput />
      </FormItem>

      <FormItem
        name="groupRules"
        label="Group bylaws and rules (Optional)"
        theme="primary"
        rules={[
          {
            message: 'Please input your groupRules!',
          },
        ]}
      >
        <Input.TextArea rows={4} placeholder="Enter Group Rules" />
      </FormItem>
    </>
  );
}

export default InformationStep;
